import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Scale, Facebook, Twitter, Linkedin, Instagram, ArrowUp } from "lucide-react";
import { contactInfo, services } from "../mock";

export default function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-[#0a1428] text-neutral-300 pt-16 pb-8 relative">
      <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-11 h-11 rounded-sm bg-[#0e1b34] border border-[#c9a961] flex items-center justify-center">
              <Scale className="text-[#c9a961]" size={22} />
            </div>
            <div>
              <div className="font-serif-display text-white text-lg font-bold">Pravin Gupta</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#c9a961]">& Associates</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-neutral-400">
            A full-service law firm delivering quick, ethical and technology-driven legal solutions across Property, Corporate, Criminal and Matrimonial law in India.
          </p>
          <div className="flex items-center gap-3 mt-5">
            {[Facebook, Twitter, Linkedin, Instagram].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full border border-neutral-700 flex items-center justify-center text-neutral-400 hover:border-[#c9a961] hover:text-[#c9a961] transition-colors">
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-serif-display text-lg mb-5 gold-underline">Practice Areas</h4>
          <ul className="space-y-2 text-sm">
            {services.slice(0, 8).map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-neutral-400 hover:text-[#c9a961] transition-colors">
                  {s.title.charAt(0) + s.title.slice(1).toLowerCase()}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-serif-display text-lg mb-5 gold-underline">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-[#c9a961] transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#c9a961] transition-colors">About Us</Link></li>
            <li><a href="/#team" className="hover:text-[#c9a961] transition-colors">Our Attorneys</a></li>
            <li><a href="/#appointment" className="hover:text-[#c9a961] transition-colors">Fix an Appointment</a></li>
            <li><Link to="/contact" className="hover:text-[#c9a961] transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-serif-display text-lg mb-5 gold-underline">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#c9a961] mt-1 flex-shrink-0" />
              <span className="text-neutral-400">{contactInfo.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#c9a961] flex-shrink-0" />
              <a href={`tel:${contactInfo.phone}`} className="text-neutral-400 hover:text-[#c9a961]">{contactInfo.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#c9a961] flex-shrink-0" />
              <div className="flex flex-col">
                <a href={`mailto:${contactInfo.email}`} className="text-neutral-400 hover:text-[#c9a961] break-all">{contactInfo.email}</a>
                <a href={`https://${contactInfo.website}`} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-[#c9a961] break-all">{contactInfo.website}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-neutral-800 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-neutral-500">
          &copy; {new Date().getFullYear()} Pravin Gupta & Associates. All rights reserved.
        </p>
        <p className="text-xs text-neutral-500">
          Disclaimer: The information on this website is not intended to be, and is not, legal advice.
        </p>
      </div>

      <button
        onClick={scrollTop}
        className="fixed bottom-6 right-6 w-11 h-11 bg-[#c9a961] hover:bg-[#b28e42] text-[#0e1b34] rounded-sm shadow-lg flex items-center justify-center transition-colors z-40"
        aria-label="Scroll to top"
      >
        <ArrowUp size={18} />
      </button>
    </footer>
  );
}
